import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../../config/endpoints.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SrcQuestionareAnsInpService {
  constructor(private http: HttpClient) { }

  getSheets(pObj: any): Observable<any> {
    return this.http.post<any>(EndpointsConfig.questionare.sheets, pObj);
  }
  getInterviewSheetInfo(pObj: any): Observable<any> {
    return this.http.post<any>(EndpointsConfig.questionare.sheetInfo, pObj);
  }
  registSheetInfo(pObj: any): Observable<any> {
    return this.http.post<any>(EndpointsConfig.questionare.registSheetInfo, pObj);
  }
  getHTOrgInfo(pHTOrgCode): Observable<any> {
    return this.http.post<any>(EndpointsConfig.common.getHTOrgInfo, JSON.stringify(pHTOrgCode));
  }
}
